export default __webpack_public_path__ + "static/media/logo.b320123e.png";